import { createSlice } from '@reduxjs/toolkit';
import { getFormUpdater } from '../../services/common/miscUtils';
import { ReduxStateWithForms, ReduxTrackedForm, createReduxTrackedFormDefaults } from '../../types/reduxTrackedForm';
import { SummaryConsentFormModel } from './summaryConsentForm.model';

export interface SummaryConsentFormState extends ReduxStateWithForms<{
  summaryConsent: ReduxTrackedForm<SummaryConsentFormModel>;
}> {}

const summaryConsentFormInitialValues: SummaryConsentFormModel = {
  marketingVWFS: false,
  emailVWFS: false,
  mobilePhoneVWFS: false,
  landlineVWFS: false,
  postVWFS: false,
  marketingBP: false,
  emailBP: false,
  mobilePhoneBP: false,
  landlineBP: false,
  postBP: false,
};

const initialState: SummaryConsentFormState = {
  forms: {
    summaryConsent: {
      ...createReduxTrackedFormDefaults<SummaryConsentFormModel>({
        initialValues: summaryConsentFormInitialValues,
      }),
      values: {
        ...summaryConsentFormInitialValues,
      },
    },
  },
};

const name = 'summaryConsentForm';

const slice = createSlice({
  name,
  initialState,
  selectors: {
    summaryConsentValues: (state) => state.forms.summaryConsent.values,
    summaryConsentTriggers: (state) => state.forms.summaryConsent.triggers,
    forms: (state) => state.forms,
  },

  reducers: {
    updateForm: getFormUpdater<SummaryConsentFormState>(),
  },
});

export const summaryConsentFormSlice = slice;
export const summaryConsentFormSliceSelectors = slice.selectors;
